import React from 'react';
import { Link } from '@blueprint/link';
import { AccountWrapper } from './AccountMenu.style';

const AccountMenu = () => (
    <AccountWrapper>
        <li>
            <Link
                href="/favourites/properties/"
                data-testid="header-profilemenu-saved-listing"
                data-track-category="User Account"
                data-track-action="clickthrough"
                data-track-label="user account>favourite properties"
            >
                Saved listings
            </Link>
        </li>
        <li>
            <Link
                href="/favourites/tracked-properties/"
                data-testid="header-profilemenu-tracked-properties"
                data-track-category="User Account"
                data-track-action="clickthrough"
                data-track-label="user account>tracked properties"
            >
                Tracked properties
            </Link>
        </li>
        <li>
            <Link
                href="/myaccount/alerts-searches/"
                data-testid="header-profilemenu-alerts-searches"
                data-track-category="User Account"
                data-track-action="clickthrough"
                data-track-label="user account>alerts & searches"
            >
                Alerts and searches
            </Link>
        </li>
        <li>
            <Link
                href="/myaccount/account/preferences/"
                data-testid="header-profilemenu-email-preferences"
                data-track-category="User Account"
                data-track-action="clickthrough"
                data-track-label="user account>email preferences"
            >
                Email preferences
            </Link>
        </li>
        <li>
            <Link
                href="/myaccount/"
                data-testid="header-profilemenu-account"
                data-track-category="User Account"
                data-track-action="clickthrough"
                data-track-label="user account>manage account"
            >
                More account settings
            </Link>
        </li>
        <li>
            <Link
                href="/?signout=1"
                data-testid="header-profilemenu-sign-out"
                data-track-category="User Account"
                data-track-action="clickthrough"
                data-track-label="user account>sign out"
                data-ajax="false"
            >
                Sign out
            </Link>
        </li>
    </AccountWrapper>
);

export default AccountMenu;
